import { swSettings } from "app/common/services/swSettings";
import { WWOTopPublishersTableContainer } from "app/pages/website-performance/components/TopPublishers/WWOTopPublishersTableContainer";
import { DEFAULT_HOOKS_MODAL_ID } from "app/pages/workspace/config/stateToWsConfigMap";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { getHooksVersion } from "app/UtilitiesAndConstants/UtilityFunctions/hooksUtils";
import { isNoTouchOrTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOTopPublishersTableContainerSI = ({ hideFooter = false }: { hideFooter?: boolean }) => {
    const params = proNavigator.getParams();

    const getCtaLink = () => {
        return {
            href: proNavigator.href("accountreview_website_display_overview", {
                ...params,
                webSource: devicesTypes.TOTAL,
            }),
            target: "_self",
        };
    };

    return (
        <WWOTopPublishersTableContainer
            getCtaLink={getCtaLink}
            unlockHook={{
                component: "WsWebDisplayTrafficPublishers",
                hookModal: isNoTouchOrTrialOrAfterTrial(swSettings) ? "trafficOverview" : DEFAULT_HOOKS_MODAL_ID,
                version: getHooksVersion(swSettings),
            }}
            hideFooter={hideFooter}
        />
    );
};
